const de = {
  title: 'Kategorieverwaltung',
  columns: {
    name: 'Kategorie'
  },
  create: {
    createModalTitle: 'Neue Kategorie',
    editModalTitle: 'Bearbeite Kategorie',
    name: 'Kategoriename'
  },
  dialogs: {
    deleteConfirm: {
      title: 'Wirklich löschen?',
      message: 'Wollen Sie wirklich die Kategorie löschen?'
    }
  },
  alerts: {
    errorLoading: 'Die Kategorien konnten nicht geladen werden',
    successfulCreate: 'Die Kategorie wurde erstellt',
    successfulUpdate: 'Die Kategorie wurde bearbeitet',
    successfulDelete: 'Die Kategorie wurde gelöscht',
    failedCreate: 'Die Kategorie konnte nicht erstellt werden',
    failedUpdate: 'Die Kategorie konnte nicht bearbeitet werden',
    failedDelete: 'Die Kategorie konnte nicht gelöscht werden'
  }
};

export default de;
export type FundingCategoriesTranslation = typeof de;
